import React from "react";
import {SidebarNav} from "@/components/ui/sidebar-nav.tsx";
import {PageTitle} from "@/components/ui/headings";
import {useTranslation} from "react-i18next";
import {AssignMenteeButton} from "@/components/AssignMenteeButton.tsx";

const sidebarNavItems = [
    { title: "mentees", href: "/suggestions" },
    { title: "mentors", href: "/suggestions/mentors" },
];

interface SuggestionsLayoutProps {
    children: React.ReactNode;
}

export default function SuggestionsLayout({ children }: SuggestionsLayoutProps) {
    const { t } = useTranslation();

    return (
        <div className="container space-y-6 py-8">
            <div className="flex flex-wrap items-start justify-between gap-4">
                <div className="space-y-1">
                    <PageTitle>{t("navbar.suggestions")}</PageTitle>
                    <p className="text-sm text-text-2">
                        {t("suggestions.desc")}
                    </p>
                </div>
                <AssignMenteeButton />
            </div>
            <div className="flex flex-col gap-8 lg:flex-row lg:gap-12">
                <aside className="lg:w-48 flex-shrink-0">
                    <SidebarNav items={sidebarNavItems} />
                </aside>
                <div className="flex-1 min-w-0">
                    <div className="bg-bg-card border border-border rounded-xl overflow-hidden p-6">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
}
